import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PlanGuard } from '@/components/guards';
import { BUILDER_PLAN_SLUG } from '@/services/auth/plan-slugs';

/**
 * The old `journeys` URLs for Collections. The pages live at `/workspaces/:workspaceId/collections`;
 * the children here redirect to them. This layout stays for the `$collectionId/$` splat, which
 * still renders the embedded app.
 */
function JourneysCollectionsLayoutRoute() {
  return (
    <PlanGuard excludedPlans={[BUILDER_PLAN_SLUG]}>
      <Outlet />
    </PlanGuard>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/collections')({
  component: JourneysCollectionsLayoutRoute,
});
